import { type JSX, useEffect, useState } from "react";
import { closeApp } from "./utils/app-helper";
import { NavigationContext } from "./context/navigation-context";

export const NavigationManager = (props: { children: JSX.Element }) => {
	const [openDrawers] = useState<{ id: string; closeDrawer: () => void }[]>([]);

	const back = () => {
		if (openDrawers.length > 0) {
			const drawer = openDrawers[openDrawers.length - 1];
			drawer?.closeDrawer();
		} else {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			if ((history.state?.idx ?? 0) > 0) {
				history.back();
			} else {
				closeApp();
			}
		}
	};

	const openDrawer = (id: string, closeDrawer: () => void) => {
		openDrawers.push({ id, closeDrawer });
	};

	const closeDrawer = (id: string) => {
		if (id) {
			const index = openDrawers.findIndex((d) => d.id === id);

			if (index >= 0) {
				openDrawers.splice(index, 1);
			}
		}
	};

	useEffect(() => {
		window.addEventListener("NavigationBack", back);

		return () => window.removeEventListener("NavigationBack", back);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<NavigationContext.Provider value={{ openDrawer, closeDrawer, back }}>
			{props.children}
		</NavigationContext.Provider>
	);
};
